import React, { FunctionComponent } from "react";
import styled from "styled-components";
import CheckIcon from "src/components/icons/Check";

export interface Props {
    name: string;
    current?: boolean;
}

const Root = styled("div")`
    align-items: center;
    display: flex;
    font-size: 13px;
`;

const Name = styled("div")<{ current: boolean }>`
    font-weight: ${({ current }) => current && 500};
`;

const IconPlaceholder = styled("div")`
    height: 12px;
    margin-left: 8px;
    width: 12px;
`;

const CheckIconContainer = styled(CheckIcon)`
    background-color: ${(props) => props.theme.palette.primary.main};
    border-radius: 50%;
    box-sizing: content-box;
    color: ${(props) => props.theme.palette.common.white};
    height: 8px;
    padding: 2px;
    width: 8px;
`;

const Step: FunctionComponent<Props> = ({ name, current = false }) => (
    <Root>
        <Name current={current}>{name}</Name>

        <IconPlaceholder>{current && <CheckIconContainer />}</IconPlaceholder>
    </Root>
);

export default Step;
